import {
  getPhoneNumber,
  PhoneNumberResponse,
  SuccessResponse,
} from '@back-office/http';
import { ISD_CODE_LENGTH } from '@back-office/ui';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';

function* getPhoneNumberRequest(
  email: string
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  try {
    const response = yield getPhoneNumber(email);
    const {
      status,
      data: { phone },
    } = (response as PhoneNumberResponse).data;

    if (status.code === 1000) {
      const phoneWithoutIsd = phone.includes('+')
        ? phone.substring(ISD_CODE_LENGTH)
        : phone;
      return Promise.resolve(phoneWithoutIsd);
    }
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    return Promise.reject(new Error(e.message));
  }
}

export default getPhoneNumberRequest;
